import { useAssignWizard } from 'pages/custom_tests/components/assign_wizard/context';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Form, Row } from 'react-bootstrap';

export const SettingsStep = () => {

    const { endDate, initialAssignedAccessCodeIds, maxAttempts, proctoring, questionReview, selectedAccessCodes, setEndDate,
        setMaxAttempts, setProctoring, setQuestionReview, setStartDate, startDate } = useAssignWizard();
    const { formatMessage } = useIntl();

    // Start/End dates apply to classroom assignments only; access codes carry their own
    // expiration, so the date range is hidden when the NEWLY selected target is an access
    // code. Pre-existing (locked) assignments keep their stored settings and don't count.
    const isAccessCodeTarget = selectedAccessCodes.some(({ Id }) => !initialAssignedAccessCodeIds.includes(Id));

    const renderToggle = (params: { id: string; checked: boolean; description: string; label: string; onChange: (checked: boolean) => void }) => (
        <div className={'d-flex align-items-start gap-3'}>
            <Form.Check
                checked={params.checked}
                id={params.id}
                onChange={e => params.onChange(e.target.checked)}
                type={'switch'}
            />
            <div>
                <div className={'fw-semibold'}>
                    {params.label}
                </div>
                <div className={'small text-muted'}>
                    {params.description}
                </div>
            </div>
        </div>
    );

    return (
        <div className={'assign-settings-step d-flex flex-column gap-4 py-2'}>

            {!isAccessCodeTarget && (
                <Row>
                    <Col className={'mb-2'} md={6} sm={12}>
                        <Form.Label className={'fw-bold'}>
                            <FormattedMessage defaultMessage="Start date" id="start_date.550355c8" />
                        </Form.Label>
                        <Form.Control
                            onChange={e => setStartDate(e.target.value)}
                            type={'date'}
                            value={startDate}
                        />
                    </Col>
                    <Col className={'mb-2'} md={6} sm={12}>
                        <Form.Label className={'fw-bold'}>
                            <FormattedMessage defaultMessage="End date" id="end_date.506f89d9" />
                        </Form.Label>
                        <Form.Control
                            min={startDate || undefined}
                            onChange={e => setEndDate(e.target.value)}
                            type={'date'}
                            value={endDate}
                        />
                    </Col>
                </Row>
            )}

            <Row>
                <Col md={6} sm={12}>
                    <Form.Label className={'fw-bold'}>
                        <FormattedMessage defaultMessage="Max attempts - leave blank for unlimited" id="max_attempts_leave_blank_for_unlimited.5821deec" />
                    </Form.Label>
                    <Form.Control
                        min={1}
                        onChange={e => setMaxAttempts(e.target.value)}
                        type={'number'}
                        value={maxAttempts}
                    />
                </Col>
            </Row>

            <Row className={'g-4'}>
                <Col md={6} sm={12}>
                    {renderToggle({
                        id: 'assign-proctoring',
                        checked: proctoring,
                        description: formatMessage({ id: 'enables_identify_verification_and_sessio.a0fcf53a', defaultMessage: 'Enables identify verification and session monitoring for this assignment' }),
                        label: formatMessage({ id: 'proctoring.4139a0f9', defaultMessage: 'Proctoring' }),
                        onChange: setProctoring
                    })}
                </Col>
                <Col md={6} sm={12}>
                    {renderToggle({
                        id: 'assign-question-review',
                        checked: questionReview,
                        description: formatMessage({ id: 'allow_students_to_review_answers_after_c.a687b9da', defaultMessage: 'Allow students to review answers after completing the test' }),
                        label: formatMessage({ id: 'question_review.9ddeb240', defaultMessage: 'Question review' }),
                        onChange: setQuestionReview
                    })}
                </Col>
            </Row>

        </div>
    );

};
